module.exports = __webpack_public_path__ + "img/step31_lift_printer_lowest.66d28d26.png";